import React from 'react'
import PropTypes from 'prop-types'
import ReferredCard from './ReferredCard'
import Alert from './Alert'

class ListReferred extends React.Component {// eslint-disable-line react/prefer-stateless-function
  render() {
    const referred = this.props.referred.map((company, index) =>
      <ReferredCard key={index} name={company.nome} companyName={company.nome_da_empresa} phone={company.telefone} email={company.email} subscribed={!!company.comprou} />) // eslint-disable-line react/no-array-index-key
    return (
      <div>
        <h4>Clientes indicados</h4>
        <br />
        <div className="list-group">
          {referred.length === 0 ?
            <Alert type="warning">
              Você não indicou ninguém até o momento <i className="em em-white_frowning_face" />
            </Alert>
            : referred}
        </div>
      </div>
    )
  }
}

ListReferred.propTypes = {
  referred: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
}

export default ListReferred



// WEBPACK FOOTER //
// ./client/components/ListReferred.js